import { render, staticRenderFns } from "./instInput.vue?vue&type=template&id=4f407eae&scoped=true"
import script from "./instInput.vue?vue&type=script&lang=js"
export * from "./instInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f407eae",
  null
  
)

export default component.exports